import { useQuery } from '@tanstack/react-query';
import wizardApi from '../../data/wizardApi';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import routes from '../../../routing/routes';
import type { CategoryFilterOption, FilterOption } from '../../domain/models';

export type CategorySelectPageViewModel = ReturnType<typeof useCategorySelectPageViewModel>;
export function useCategorySelectPageViewModel() {
  const navigate = useNavigate();
  const [selectedCategoryId, setSelectedCategoryId] = useState<string | null>(null);

  const categoryOptions = useQuery({
    queryKey: ['categoryOptions'],
    queryFn: async () => {
      const categories = await wizardApi.getCategoryOptions();
      setSelectedCategoryId(categories[0]?.id || null);
      return categories;
    },
  });

  const setSelectedCategory = (option: FilterOption, checked: boolean) => {
    if (checked) {
      setSelectedCategoryId(option.id);
    }
  };

  const submit = () => navigate(routes.createWizardFlavourUrl(selectedCategoryId!, []));

  return {
    loading: categoryOptions.isPending,
    error: categoryOptions.error,
    options: categoryOptions.data || [],

    setSelectedCategory,
    isCategorySelected: (option: CategoryFilterOption) => selectedCategoryId === option.id,
    submit,
  };
}
